export default __webpack_public_path__ + "static/syncstage-built-for-security-e35db69d5f8af8e3549e59985750ef18.png";